import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    width: '100%',
    padding: `0 ${spacing(3)} ${spacing(3)}`
  },
  selectControl: {
    width: '100%'
  }
}))
